export const GET_SAML_SETTINGS = 'GET_SAML_SETTINGS';
export const GET_SAML_SETTINGS_START = `${GET_SAML_SETTINGS}_START`;
export const GET_SAML_SETTINGS_SUCCESS = `${GET_SAML_SETTINGS}_SUCCESS`;
export const GET_SAML_SETTINGS_FAIL = `${GET_SAML_SETTINGS}_FAIL`;
export const UPDATE_SAML_SETTINGS = 'UPDATE_SAML_SETTINGS';
export const UPDATE_SAML_SETTINGS_START = `${UPDATE_SAML_SETTINGS}_START`;
export const UPDATE_SAML_SETTINGS_SUCCESS = `${UPDATE_SAML_SETTINGS}_SUCCESS`;
export const UPDATE_SAML_SETTINGS_FAIL = `${UPDATE_SAML_SETTINGS}_FAIL`;
export const UPLOAD_SAML_CERTIFICATE = 'UPLOAD_SAML_CERTIFICATE';

export const getSamlSettings = () => {
  const params = {
    embed: 'saml,saml.certificateDetails',
  };

  return {
    type: GET_SAML_SETTINGS,
    meta: {
      xmApi: true,
      method: 'get',
      uri: '/webapi/xm/1/settings',
      params,
    },
  };
};

export const uploadCertificate = file => {
  return {
    type: UPLOAD_SAML_CERTIFICATE,
    meta: {
      xmApi: true,
      method: 'post',
      uri: '/webapi/xm/1/settings/samlcertificate',
      contentType: 'multipart/form-data',
      params: {
        hasFile: true,
        file,
        name: file.name,
      },
    },
  };
};
